"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MODAL_HEADER_ALIGN_TITLE", {
  enumerable: true,
  get: function get() {
    return _constants.MODAL_HEADER_ALIGN_TITLE;
  }
});
exports["default"] = exports.ModalHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _lodash = _interopRequireDefault(require("lodash.isfunction"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _CloseLargeIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/CloseLargeIcon"));
var _styled = require("../styled");
var _constants = require("../constants");
var _excluded = ["alignTitle", "children", "hasBorderBottom", "modalHasContent", "iconCloseTitle", "buttonCloseRef", "onClose", "testId", "theme", "title", "titleProps"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ModalHeader = function ModalHeader(_ref) {
  var alignTitle = _ref.alignTitle,
    children = _ref.children,
    hasBorderBottom = _ref.hasBorderBottom,
    modalHasContent = _ref.modalHasContent,
    iconCloseTitle = _ref.iconCloseTitle,
    buttonCloseRef = _ref.buttonCloseRef,
    onClose = _ref.onClose,
    testId = _ref.testId,
    theme = _ref.theme,
    title = _ref.title,
    titleProps = _ref.titleProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var rendersCloseButton = (0, _lodash["default"])(onClose);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_styled.HeaderContainer, _extends({
    hasBorderBottom: hasBorderBottom,
    modalHasContent: modalHasContent,
    onClose: onClose,
    testId: testId
  }, props), (title || rendersCloseButton) && /*#__PURE__*/_react["default"].createElement(_styled.HeaderTitleWrapper, null, title && /*#__PURE__*/_react["default"].createElement(_styled.HeaderTitle, _extends({
    alignTitle: alignTitle
  }, titleProps), title), rendersCloseButton && /*#__PURE__*/_react["default"].createElement(_styled.HeaderCloseIcon, {
    ref: buttonCloseRef,
    title: iconCloseTitle,
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_CloseLargeIcon["default"], {
    role: "none"
  }))), children && /*#__PURE__*/_react["default"].createElement(_styled.HeaderSubtitle, null, children)));
};
exports.ModalHeader = ModalHeader;
ModalHeader.propTypes = {
  alignTitle: _propTypes["default"].oneOf(Object.values(_constants.MODAL_HEADER_ALIGN_TITLE)),
  children: _propTypes["default"].node,
  hasBorderBottom: _propTypes["default"].bool,
  modalHasContent: _propTypes["default"].bool,
  iconCloseTitle: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  testId: _propTypes["default"].string,
  theme: _propTypes["default"].object.isRequired,
  title: _propTypes["default"].string,
  buttonCloseRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  titleProps: _propTypes["default"].object
};
ModalHeader.defaultProps = {
  alignTitle: _constants.MODAL_HEADER_ALIGN_TITLE.LEFT,
  children: null,
  hasBorderBottom: false,
  modalHasContent: true,
  onClose: undefined,
  iconCloseTitle: 'Close',
  testId: 'MODAL_HEADER',
  title: '',
  buttonCloseRef: undefined,
  titleProps: {}
};
var _default = (0, _oxygenConfig.withTheme)(ModalHeader, 'modal');
exports["default"] = _default;